import { Translate } from 'react-redux-i18n'
import StepFile from './step-file'
import Dashboard from 'endpoints/dashboard'

let getStatus = ({ release, draft }) => draft ? draft.status : release.status;
let getStatusI = status => ['VALID', 'CHANGED', 'OUTDATED', 'INVALID'].indexOf(status);
let isOutdated = status => status === 'OUTDATED';

export default class extends React.Component {
  constructor() {
    super();
    this.state = { isOpen: false, selected: [], activeGeneration: false };
    this.toggle = this.toggle.bind(this);
    this.startAutoGenerate = this.startAutoGenerate.bind(this);
  }

  componentWillReceiveProps(props) {
    if(props.group.key !== 'dependencies') return;
    if(this.state.selected.length === 0) return;
    let draftWasChanged = props.files.findIndex((file, i) => JSON.stringify(file[1]) === JSON.stringify(this.props.files[i][1])) !== -1;
    if(draftWasChanged || props.disabled) {
      this.setState({ selected: [] });
    }
  }

  toggle(e) {
    e.preventDefault();
    this.setState({ isOpen: !this.state.isOpen });
  }

  toggleStep(key, e) {
    e.preventDefault();
    if(this.props.disabled) return;
    let { selected } = this.state;
    if(selected.includes(key)) {
      this.setState({ selected: selected.filter(k => k !== key) });
    } else {
      this.setState({ selected: selected.concat([key]) });
    }
  }

  startAutoGenerate() {
    this.setState({ activeGeneration: true });
    Dashboard.autoGenerateFiles(this.state.selected).then(
      () => this.setState({ activeGeneration: false, selected: [] }),
      () => this.setState({ activeGeneration: false })
    );
  }

  render() {
    let body, footer;
    let { files } = this.props;

    let status = files.reduce((acc, file) => {
      let fileStatus = getStatus(file);
      if(acc && getStatusI(fileStatus) < getStatusI(acc)) {
        return acc;
      } else {
        return fileStatus;
      }
    }, '');

    if(this.state.isOpen) {
      let isOutdatedDeps = this.props.group === 'dependencies' && isOutdated(status);
      let { selected } = this.state;
      let hoverStyle = { top: null, height: null, size: 100 / files.length };
      let tiles = files.map((file, i) => {
        let prefixBtn;
        let key = file.draft.type;
        if(isOutdatedDeps) {
          let isSelected = selected.includes(key);
          if(this.state.activeGeneration || this.props.activeSteps.includes(key)) {
            if(hoverStyle.top === null) {
              hoverStyle.top = hoverStyle.size * i;
            }
            hoverStyle.height = hoverStyle.size * (i + 1) - hoverStyle.top;
          } else {
            if(isOutdated(getStatus(file))) {
              prefixBtn = (
                <a
                  href={this.props.disabled ? false : '#'}
                  className={`fa fa-3x fa-${isSelected ? 'check-square-o' : 'square-o'} m-auto`}
                  onClick={this.toggleStep.bind(this, key)}
                />
              );
            } else {
              // to prevent UI overflow - put an empty element
              prefixBtn = (<span />);
            }
          }
        }

        return (
          <StepFile
            key={key}
            id={key}
            releaseFile={file.release}
            draftFile={file.draft}
            prefixBtn={prefixBtn}
            disabled={this.props.disabled}
          />
        );
      });

      let hover;
      if(hoverStyle.top !== null) {
        let styles = { top: `${hoverStyle.top}%`, height: `${hoverStyle.height}%` };
        hover = (
          <div className="step-file_upload text-center" style={styles}>
            <h3 className="text-uppercase"><Translate value="home.step_file.auto_generate" /></h3>
            <div>
              <span className="fa fa-spinner fa-pulse fa-3x" />
            </div>
          </div>
        );
      }
      body = (
        <div className="card-body">
          {tiles}
          {hover}
        </div>
      );

      if(isOutdatedDeps) {
        let isBtnDisabled = this.props.disabled || (selected.length === 0) || this.state.activeGeneration;
        footer = (
          <div className="card-footer d-flex align-items-end">
            <div className="pr-5">
              <label className="d-block font-weight-bold"><Translate value="home.step_group.outdated.title" /></label>
              <Translate value="home.step_group.outdated.description" />
            </div>
            <button type="button" className="btn btn-primary ml-auto" disabled={isBtnDisabled} onClick={this.startAutoGenerate}>
              <Translate value="home.step_group.outdated.auto_generate" />
              <span className="fa fa-cog ml-1" />
            </button>
          </div>
        );
      }
    }

    return (
      <div className="card card--step-group">
        <div className="card-header" onClick={this.toggle}>
          <h3>
            {`${this.props.index}. `}
            <Translate value={`enums.step_group.${this.props.group}`} />
          </h3>
          <span className={`ml-auto status-icon status-icon--${status.toLowerCase()}`} />
          <a href="#" className={`fa fa-angle-${this.state.isOpen ? 'up' : 'down'}`} />
        </div>
        {body}
        {footer}
      </div>
    );
  }
}
